import React from 'react';
import './style.css';

export const NavItemSeparator = (props: { color: string; height?: number }) => (
  <div
    className="header-navbar_divider"
    style={{ background: props.color, height: props.height ?? 26, width: 1 }}
  />
);
